import { render, staticRenderFns } from "./LibraryResourceCard.vue?vue&type=template&id=5da07818&scoped=true&"
import script from "./LibraryResourceCard.vue?vue&type=script&lang=js&"
export * from "./LibraryResourceCard.vue?vue&type=script&lang=js&"
import style0 from "./LibraryResourceCard.vue?vue&type=style&index=0&id=5da07818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da07818",
  null
  
)

export default component.exports